"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const AppBaseComponent_1 = require("../../../commons/AppBaseComponent");
const map_service_1 = require("../../../commons/map.service");
const app_service_1 = require("../../../commons/app.service");
const material_1 = require("@angular/material");
const router_1 = require("@angular/router");
const _4d_mapper_1 = require("4d-mapper");
const map_component_1 = require("../map.component");
const application_events_service_1 = require("../../../xs/services/events/application-events.service");
class CreditNotesComponent extends AppBaseComponent_1.AppBaseComponent {
    constructor(fourD, service, router, snackBar, dialog, mapService, mapComp, applicationEvents) {
        super(service, router, snackBar, dialog, applicationEvents);
        this.fourD = fourD;
        this.service = service;
        this.router = router;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.mapService = mapService;
        this.mapComp = mapComp;
    }
    openCreditNotes() {
        let creditFound = false;
        let companyDetails = '';
        let companyNames = '';
        [this.mapService.scene].forEach(scene => {
            if (scene['creditBy']) {
                creditFound = true;
                companyNames += ', ' + scene['creditBy'];
            }
            scene._cachedTransforms.forEach(ct => {
                if (ct['creditBy']) {
                    creditFound = true;
                    companyNames += ', ' + ct['creditBy'];
                }
            });
        });
        if (this.fourD.domainConfig) {
            if (this.fourD.domainConfig['credits'])
                companyDetails += this.fourD.domainConfig['credits'];
            else if (creditFound) {
                companyDetails += 'Data is provided by ' + companyNames.substr(1, companyNames.length) + '\n\n';
            }
            if (this.fourD.domainConfig['credits_info'])
                companyDetails += '\r\n' + this.fourD.domainConfig['credits_info'];
        }
        else
            companyDetails += '@Copyright MapSender Pty Ltd. 2022 ' + '\n\n' + 'Front-end visualization uses CesiumJS WEBGL and requires WEBGL compatible browsers such as Chrome or Firefox.';
        this.openDialog('', companyDetails).subscribe();
    }
}
exports.CreditNotesComponent = CreditNotesComponent;
